/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Mst Service
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ItemApi} from '../../api/master/item-mst.api';
import { switchMap, map } from 'rxjs/operators';
import { ItemData,Item  } from '../../interface/master/item-mst';

@Injectable()
export class ItemService extends ItemData {

  constructor(private api: ItemApi) {
    super();
  }


  list(url: string): Observable<Item[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Item>{
      return this.api.getById(url);
  }

  create(url: string, data:Item): Observable<Item> {
    return this.api.add(url,data);
  }

  update(url: string, data:Item): Observable<Item> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
